export default "__VITE_ASSET__BXcXovEJ__"